import { SmartContract, useContract } from '@thirdweb-dev/react';
import { EMPTY_ADDRESS } from '@app/constants/common';
import { Address } from '@thirdweb-dev/sdk';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { ethers } from 'ethers';
import { useConfig } from '@app/config';

async function fetcher(
  contract: SmartContract<ethers.BaseContract> | undefined,
  vaultAddress: Address
) {
  if (!contract || !vaultAddress) {
    return null;
  }

  const nftPoolAddress = await contract.call('getPool', [vaultAddress]);

  return nftPoolAddress === EMPTY_ADDRESS ? null : nftPoolAddress;
}

export function useNftPoolAddress(vaultAddress: Address) {
  const config = useConfig();
  const { contract: poolFactoryContract } = useContract(
    config?.CONTRACTS.NFT_POOL_FACTORY
  );

  const isContractReady = !!poolFactoryContract;

  return useQuery(
    [QueryKeys.NFT_POOL_ADDRESS, vaultAddress, isContractReady],
    () => fetcher(poolFactoryContract, vaultAddress)
  );
}
